import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/login/banner.png';
import _imports_1 from '@/assets/img/login/banner_h5.png';
import _imports_2 from '@/assets/img/login/logo.png';
import _imports_3 from '@/assets/img/login/bg.png';
import _imports_4 from '@/assets/img/login/user.png';
import _imports_5 from '@/assets/img/login/phone.png';
import _imports_6 from '@/assets/img/login/company.png';
const _withScopeId = n => (_pushScopeId("data-v-0efbeeaa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "banner_box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner hidden-xs-only",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner hidden-sm-and-up",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "logo hidden-xs-only",
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "title hidden-xs-only"
}, "智慧营销领航者"), /*#__PURE__*/_createElementVNode("div", {
  class: "tip hidden-xs-only"
}, " 高净值、本地生活、DTC领域新消费场景 ")], -1));
const _hoisted_7 = {
  class: "right"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg hidden-xs-only",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "立即申请使用"), /*#__PURE__*/_createElementVNode("div", {
  class: "line"
})], -1));
const _hoisted_10 = {
  class: "item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_12 = {
  class: "item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_14 = {
  class: "item"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_6,
  alt: ""
}, null, -1));
import { onUnmounted, reactive, ref } from "vue";
import { Notify } from "vant";
import { ElMessage } from "element-plus";
import { Api } from "@/api";
import { useRouter } from "vue-router";
const __default__ = {
  metaInfo: {
    title: "免费试用-京奇数据智慧营销",
    meta: [{
      name: "description",
      content: "欢迎登录四川京奇数据科技有限公司官方网站。通过登录，您可以访问专属服务、查看项目案例、管理您的账户，并享受更多个性化体验。如果您尚未注册，请点击注册按钮开始您的旅程。"
    }, {
      name: "keywords",
      content: "四川京奇数据科技登录、用户登录、账户登录、注册新账户、客户登录、会员登录、登录页面"
    }],
    link: [{
      rel: "",
      href: ""
    }]
  }
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Login',
  setup(__props) {
    const formRef = ref();
    const router = useRouter();
    const form = reactive({
      name: "",
      phone: void 0,
      companyName: ""
    });
    const rules = {
      name: [{
        required: true,
        message: "请输入您的姓名",
        trigger: "blur"
      }],
      phone: [{
        type: "number",
        required: true,
        message: "请输入您的手机号",
        trigger: "blur"
      }, {
        pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
        message: "请输入正确的手机号"
      }],
      code: [{
        required: true,
        message: "请输入验证码",
        trigger: "blur"
      }],
      companyName: [{
        required: true,
        message: "请输入您的公司名称",
        trigger: "blur"
      }]
    };
    const isSent = ref(false);
    const count = ref(60);
    const timer = ref();
    const isOrder = ref(false);
    const toast = msg => {
      if (globalThis.matchMedia("(max-width: 767px)").matches) {
        Notify({
          type: "danger",
          message: msg
        });
      } else {
        ElMessage.error(msg);
      }
    };
    const toastSuccess = msg => {
      if (globalThis.matchMedia("(max-width: 767px)").matches) {
        Notify({
          type: "success",
          message: msg
        });
      } else {
        ElMessage.success(msg);
      }
    };
    const countDown = () => {
      timer.value = setInterval(() => {
        if (count.value <= 0) {
          clearInterval(timer.value);
          isSent.value = false;
          count.value = 60;
          return;
        }
        count.value--;
      }, 1000);
    };
    const getCode = () => {
      formRef.value.validateField("phone", async valid => {
        if (valid) {
          if (isSent.value) return;
          const res = await Api.getAuthCode({
            phone: form.phone
          });
          if (res.code === 0) {
            isSent.value = true;
            countDown();
          } else {
            isSent.value = false;
            toast(res.msg);
          }
        }
      });
    };
    const order = async () => {
      formRef.value.validate(async valid => {
        if (valid) {
          if (isOrder.value) return;
          isOrder.value = true;
          const res = await Api.submit(form);
          if (res.code === 0) {
            toastSuccess("感谢您的信任，我们将第一时间跟您联系！");
            setTimeout(() => {
              router.back();
              isOrder.value = false;
            }, 1000);
          } else {
            toast(res.msg);
            isOrder.value = false;
          }
        }
      });
    };
    onUnmounted(() => clearInterval(timer.value));
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        class: "bottom",
        model: form,
        rules: rules
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_form_item, {
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "input",
            type: "text",
            modelValue: form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "请输入您的姓名"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_el_form_item, {
          prop: "phone"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "input",
            type: "text",
            modelValue: form.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.phone = $event),
            modelModifiers: {
              number: true,
              trim: true
            },
            placeholder: "请输入您的手机号"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_el_form_item, {
          prop: "companyName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "input",
            type: "text",
            modelValue: form.companyName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.companyName = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "请输入您的公司名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", {
          class: "order",
          onClick: order
        }, "立即预约")]),
        _: 1
      }, 8, ["model"])])])])]);
    };
  }
});